export const subscriptionStatus = /** @type {const} */ ({
  ACTIVE: 'active',
  EXPIRED: 'expired',
});

export const subscriptionRecurrence = /** @type {const} */ ({
  NONE: 'none',
  MONTH: 'month',
  YEAR: 'year',
});

export const subscriptionLanguage = /** @type {const} */ ({
  FRENCH: 'fr',
  SPANISH: 'es',
  ALL: 'all',
});

/**
 * @typedef {(typeof subscriptionLanguage)[keyof typeof subscriptionLanguage]} SubscriptionLanguage
 */

/**
 * @typedef SubscriptionType
 * @property {number} id
 * @property {string} code
 * @property {string} name
 * @property {number} monthPrice
 * @property {number} yearPrice
 * @property {SubscriptionLanguage} language
 */

/** @type {{ [key: string]: SubscriptionType }} */
export const subscriptionTypes = {
  teacherPro: {
    id: 1,
    code: 'teacherPro',
    name: 'Pro',
    monthPrice: 39,
    yearPrice: 349,
    language: 'es',
  },
  teacher: {
    id: 2,
    code: 'teacher',
    name: 'Classroom',
    monthPrice: 29,
    yearPrice: 249,
    language: 'es',
  },
  family: {
    id: 3,
    code: 'family',
    name: 'Content',
    monthPrice: 19,
    yearPrice: 189,
    language: 'es',
  },
};

export const communityAddon = {
  name: 'Community',
  monthPrice: 20,
  yearPrice: 150,
};

/** @type {SubscriptionType[]} */
export const legacySubscriptionTypes = [
  {
    id: 1,
    code: 'teacherPro',
    name: 'Teacher Pro',
    monthPrice: 40,
    yearPrice: 299,
    language: 'es',
  },
  {
    id: 2,
    code: 'teacher',
    name: 'Teacher',
    monthPrice: 20,
    yearPrice: 199,
    language: 'es',
  },
  {
    id: 3,
    code: 'family',
    name: 'Family',
    monthPrice: 20,
    yearPrice: 99,
    language: 'es',
  },
  {
    id: 4,
    code: 'teacherPro',
    name: 'Teacher Pro',
    monthPrice: 19,
    yearPrice: 119,
    language: 'fr',
  },
  {
    id: 5,
    code: 'teacher',
    name: 'Teacher',
    monthPrice: 14,
    yearPrice: 79,
    language: 'fr',
  },
  {
    id: 6,
    code: 'family',
    name: 'Family',
    monthPrice: 14,
    yearPrice: 49,
    language: 'fr',
  },
  {
    id: 7,
    code: 'teacherPro',
    name: 'Teacher Pro',
    monthPrice: 59,
    yearPrice: 399,
    language: 'all',
  },
  {
    id: 8,
    code: 'teacher',
    name: 'Teacher',
    monthPrice: 29,
    yearPrice: 249,
    language: 'all',
  },
  {
    id: 9,
    code: 'family',
    name: 'Family',
    monthPrice: 29,
    yearPrice: 129,
    language: 'all',
  },
];

export const frenchTeacherProSubscriptionTypeId = 4;
export const allTeacherProSubscriptionTypeId = 7;

export const teacherProSubscriptionIds = [
  subscriptionTypes.teacherPro.id,
  frenchTeacherProSubscriptionTypeId,
  allTeacherProSubscriptionTypeId,
];

export const frenchTeacherSubscriptionTypeId = 5;
export const allTeacherSubscriptionTypeId = 8;

export const basicSubscriptionTypeIds = [
  subscriptionTypes.teacher.id,
  frenchTeacherSubscriptionTypeId,
  allTeacherSubscriptionTypeId,
];

export const defaultFreeTrialSubscriptionTypeId =
  subscriptionTypes.teacherPro.id;

export const yearDiscount = '28%';

export const priceByOptions = {
  month: {
    value: subscriptionRecurrence.MONTH,
    label: 'Monthly',
    plausibleEvent: 'view_monthly',
  },
  year: {
    value: subscriptionRecurrence.YEAR,
    label: 'Yearly',
    plausibleEvent: 'view_yearly',
  },
};
